import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { AsyncActionCreator } from 'typesafe-actions';

import axiosClient from '@lib/utils/axiosClient';

import { updateLoading } from 'actions';

export type UseReduxMutationConfig = AxiosRequestConfig & {
  callbackSuccess?: (response: AxiosResponse<any>) => void;
  callbackError?: (error: any) => void;
  showLoading?: boolean;
};

export default function useReduxMutation(
  action: AsyncActionCreator<any, any, any>,
): [(config: UseReduxMutationConfig, payload?: any) => void, boolean] {
  const dispatch = useDispatch();
  const [isPending, setPending] = useState(false);

  const execute = useCallback(
    (config: UseReduxMutationConfig, payload?: any) => {
      setPending(true);

      // Show loading
      if (config.showLoading) {
        dispatch(updateLoading(true));
      }
      dispatch(action.request(payload));
      axiosClient
        .request(config)
        .then((response) => {
          setPending(false);
          dispatch(action.success({ ...response, requestPayload: payload }));
          if (config.callbackSuccess) {
            config.callbackSuccess(response);
          }
          // Hide loading
          if (config.showLoading) {
            dispatch(updateLoading(false));
          }
        })
        .catch((error) => {
          setPending(false);
          dispatch(action.failure(error));
          if (config.callbackError) {
            config.callbackError(error);
          }
          // Hide loading
          if (config.showLoading) {
            dispatch(updateLoading(false));
          }
        });
    },
    [dispatch, action],
  );

  return [execute, isPending];
}
